// src/theme/colors.ts
import colors from 'tailwindcss/colors';

export const baseColors = {
    background: "#121212",
    background2: "#141414",
    headline1: colors.neutral[50],
    headline2: colors.neutral[200],
    body1: colors.neutral[400],
    body2: colors.neutral[500],
    footer: colors.neutral[800],
    divider: colors.neutral[400],
    border: "#181818"
};

export const mainColorPalette = {
    primary: colors.purple[700],
    secondary: colors.purple[950],
    accent: colors.blue[700],
    button: {
        text: colors.purple[50],
        state: {
            default: colors.purple[700],
            hover: colors.purple[950],
        },
    },
    link: {
        text: colors.purple[50],
        state: {
            default: colors.purple[400],
            hover: colors.purple[300],
        },
    },
};

const themeColors = {
    base: baseColors,
    blueTheme: mainColorPalette
};

export default themeColors;
